(function($) {
		
	function openStatistics() {
		document.location = statsUrl;
	}
	
	function getVersionAndBuild() {
		$.getJSON(baseCesURL + 'maintenance/getInstalledProducts', { nocache: new Date().getTime() }, function(response){
    		
    		var version;
    		var build;
    		
    		for(index in response.products) {
    			var product = response.products[index];
    			if(product.name.indexOf(productText) !== -1) {
    				var splitIndex = product.version.lastIndexOf('.');
    				$('.about-version-num').html(versionText + ' ' + product.version.slice(0, splitIndex));
    				$('.about-build-num').html(buildText + ' ' + product.version.slice(splitIndex + 1));
    			}
    		}

    	});
	}
	
    $(document).ready(function() {
    	
    	$('#copyrightCurrentYear').text(new Date().getFullYear());
    	
    	$.openAbout = function(){
	    	var sourceElement = '#helpButton';
	        var collectSupportDialogDisplayed = $('.collect-support-files-dialog:visible').length > 0;
	        var aboutDialogCreated = $('.about-dialog').length > 0;
	        
	        //If the collect support files dialog is currently visible OVER an existing about modal,
	        //just close the collect support files dialog and show the existing about modal
	    	if(collectSupportDialogDisplayed && aboutDialogCreated) {
		    	$('.collect-support-files-dialog').find('button:contains(' + cancelText + ')').click();
			} else {
				$('#aboutDialog').dialog({
		            modal: true,
		            width: 600,
		            maxWidth: '90%',
		            fluid: true,
		            draggable : false,
		            resizable : false,
		            classes: {'ui-dialog': 'about-dialog'},
		            buttons : {
		                "OK" : {
		                    text : okButtonText,
		                    "class" : 'ok-button',
		                    click : function() {
		                        $(this).dialog('close');
		                    }
		                }
		            },
		            open: function() {
		            	getVersionAndBuild();
		            	
		            	if(!!productTitle) {
		            		$('#aboutDialog').dialog('option', 'title', productTitle);
		            	}
		            }
		        });
			}
		}
    	
    	if (typeof statsEnabled  !== 'undefined'){
    		if ( ! statsEnabled ) {
    			$('#statsButton').attr('disabled', true);
    		} else {
    			$('#statsButton').on('click', openStatistics);
    		}
    	}
    });
})(jQuery);
